import { FolderSmallIcon } from "@faro-lotv/flat-ui";
import { Box, Stack, SvgIcon } from "@mui/material";
import { sphereColors } from "@styles/common-colors";

interface Props {
  caption: string;
}

/** Helper component for DataTypePopover to display a single file type entry. */
export function DataTypeComponent({ caption }: Props): JSX.Element {
  return (
    <Stack gap="10px" sx={{
      ml: "10px",
      mr: "10px",
      alignItems: "center",
    }}>
      <Box sx={{
        width: "60px",
        height: "60px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        backgroundColor: "#29303D",
      }}>
        <SvgIcon
          inheritViewBox
          component={FolderSmallIcon}
          sx={{
            height: "30px",
            width: "30px",
            color: sphereColors.blue300,
        }}/>
      </Box>

      <Box sx={{ color: sphereColors.blue300 }}>
        { caption }
      </Box>
    </Stack>
  );
}
